import React from 'react';
import styled from 'styled-components';
import ArticleNum from './ArticleNum';

import { skillData } from '../data/AboutData';
import ProgressBar from './ProgressBar';

function SkillCont() {
  return (
    <SkillWrapper>
        <ArticleNum number="03" title="SKILL SET" />
        <div className="skills">
          {skillData.map(skill=>(
            <div key={skill.title} className="skillcard">
              <img src={skill.icon} className = "skillIcon" alt="icon" />
              <div className='nameprog-cont' >
                <div className='name-cont' >
                  <p className="fs-2 name" >{skill.title}</p>
                  <p className='text-tertiary' >{skill.percentage}%</p>
                </div>
                <ProgressBar percentage={skill.percentage}/>
              </div>
            </div>
          ))}
        </div>
    </SkillWrapper>
  );
}


const SkillWrapper = styled.div`
    width: 100%;
    padding: 3rem 0rem;
    /* border: 2px solid red; */

    .skills{
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(400px, 6fr));
      grid-row-gap: 4rem;
      grid-column-gap: 5rem;
      padding: 6rem 0rem;
      width: 80%;
      margin: auto;
      /* border: 2px solid red; */
    }

    .skillcard{
      display: flex;
      /* border: 2px solid red; */
    }
    img{
      margin-right: 1rem;
      width: 60px;
    }
    .nameprog-cont{
      width: 100%;
    }
    .name-cont{
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex: 1;
      margin-bottom: 0.5rem;
    }
    .name{
      color: var(--primary);
    }

    @media only screen and (max-width: 500px){
      .skills{
        grid-template-columns: repeat(auto-fit, minmax(200px, 6fr));
      }
    }

`

export default SkillCont;